import { Box, Fieldset, Stack } from '@chakra-ui/react';
import type { FormEventHandler, ReactNode } from 'react';
import Content from './Content';
import FormActions from './FormActions';

interface FormPageProps {
    title: string;
    description: string;
    onSubmit: FormEventHandler<HTMLFormElement>;
    actions: ReactNode;
    children: ReactNode;
    invalid?: boolean;
    maxW?: '3xl' | '5xl';
}

const FormPage = ({ title, description, onSubmit, actions, children, invalid, maxW = '3xl' }: FormPageProps) => (
    <Content title={title} description={description}>
        <Box maxW={maxW} mx='auto' minW='0'>
            <form noValidate onSubmit={onSubmit}>
                <Fieldset.Root minW='0' invalid={invalid}>
                    <Stack gap='6' minW='0'>
                        {children}
                        <FormActions>{actions}</FormActions>
                    </Stack>
                </Fieldset.Root>
            </form>
        </Box>
    </Content>
);

export default FormPage;
